function SyncingPromise(sync, promise) {
  promise = promise.finally(sync)
  return {
    then: (...args) => SyncingPromise(sync, promise.then(...args)),
    catch: (...args) => SyncingPromise(sync, promise.catch(...args)),
    finally: (...args) => SyncingPromise(sync, promise.finally(...args)),
    __proto__: SyncingPromise.prototype,
  }
}

module.exports = SyncingPromise
